import {
  NodeViewWrapper,
  NodeViewProps,
  ReactNodeViewRenderer,
} from '@tiptap/react'
import { Video as PrimitiveVideo } from '@basehub/tiptap-api-utils'
import ReactTextareaAutosize from 'react-textarea-autosize'
import * as React from 'react'

export const Video = PrimitiveVideo.extend({
  addNodeView() {
    return ReactNodeViewRenderer(VideoNodeView, {
      className: 'rt-video',
    })
  },
  addKeyboardShortcuts() {
    return {
      ArrowDown: ({ editor }) => {
        const selectedNode = editor.view.dom.querySelector(
          '.ProseMirror-selectednode'
        )
        if (selectedNode && selectedNode.classList.contains('rt-video')) {
          const input = selectedNode.querySelector('textarea')
          input?.focus()
          return true
        }
        return false
      },
    }
  },
})

const VideoNodeView = ({
  updateAttributes,
  node,
  editor,
  getPos,
}: NodeViewProps) => {
  const videoRef = React.useRef<HTMLVideoElement>(null)

  React.useEffect(() => {
    if (videoRef.current) {
      videoRef.current.classList.add('video-loading')
      videoRef.current.onloadeddata = () => {
        videoRef.current?.classList.remove('video-loading')
      }
    }
  }, [node.attrs.src])

  return (
    <NodeViewWrapper as="figure">
      <video
        data-drag-handle
        draggable={true}
        poster={node.attrs.poster}
        ref={videoRef}
        src={node.attrs.src}
        controls
        width={node.attrs.width}
        height={node.attrs.height}
        aspect-ratio={
          node.attrs.width && node.attrs.height
            ? `${node.attrs.width} / ${node.attrs.height}`
            : 'auto'
        }
        style={{
          aspectRatio:
            node.attrs.width && node.attrs.height
              ? `${node.attrs.width} / ${node.attrs.height}`
              : 'auto',
        }}
      />
      {editor.isEditable ? (
        <ReactTextareaAutosize
          minLength={1}
          placeholder="Caption..."
          value={node.attrs.caption ?? ''}
          onChange={(e) => {
            updateAttributes({
              caption: e.target.value,
            })
          }}
          onKeyDown={(e) => {
            if (e.key === 'Escape' || e.key === 'Tab') {
              e.preventDefault()
              editor.commands.focus(getPos() + node.nodeSize)
              return
            } else if (e.key === 'ArrowDown') {
              e.preventDefault()
              const pos = getPos()
              editor.commands.focus(pos + node.nodeSize + 1)
              return
            } else if (e.key === 'ArrowUp') {
              e.preventDefault()
              const pos = getPos()
              editor.commands.focus(pos - 1)
              return
            }
          }}
        />
      ) : (
        <figcaption>{node.attrs.caption}</figcaption>
      )}
    </NodeViewWrapper>
  )
}
